exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._358zCrG9eAKqE0fIj0NbFv{margin-bottom:20px}html[dir] .RBt3kJYg08sOSv3anuv_s{padding-bottom:10px}._3-TMhM2wezwjhFBblcUrVw{width:300px}._2l_WmNzC7zNu1ZLGcDQ_Yr{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}html[dir] ._2l_WmNzC7zNu1ZLGcDQ_Yr{padding-bottom:10px}", ""]);

// exports
exports.locals = {
	"txpEventsPanel": "_358zCrG9eAKqE0fIj0NbFv",
	"txpPrivateOption": "RBt3kJYg08sOSv3anuv_s",
	"entitySettingDropdown": "_3-TMhM2wezwjhFBblcUrVw",
	"dropDownDiv": "_2l_WmNzC7zNu1ZLGcDQ_Yr"
};